<main>
  <h2>
    {{
      entryData().uniprotDescription &&
      entryData().uniprotDescription.length > 40
        ? (entryData().uniprotDescription | slice : 0 : 40) + "..."
        : entryData().uniprotDescription
    }}
  </h2>
  <p class="entry-title">
    {{ entryData().modelEntityId }}-v{{ entryData().latestVersion }}
  </p>
  <div class="dataset">
    <span class="entry-title dataset">Google DeepMind dataset</span>
    <app-entry-status
      [isSummary]="true"
      [isProteome]="entryData().isUniProtReferenceProteome"
      [isReviewed]="entryData().isUniProtReviewed"
    ></app-entry-status>
  </div>

    <nav class="table-of-contents">
      <div class="container-border">
        <div class="nav-title" (click)="toggleNavigationLinks()">
          <h5>In this overview page</h5>
          <img src="/assets/img/mobile/arrow-{{isFullLinksDisplayed() ? 'up':'down'}}.svg" alt="arrow-up"/>
        </div>
        @if(isFullLinksDisplayed()){ @for(link of navigationLinks; track link.id){
        <a (click)="scrollToSection($event, link.id)">{{link.title}}</a>
        } } @else {
        <a (click)="scrollToSection($event, currentNavigationLink().id)">{{currentNavigationLink().title}}</a>
        }
      </div>
    </nav>
  
    <section *ngIf="isOldUniprotEntry" class="notification">
        <notification-msg 
            [type]="'warning'" 
            [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
        </notification-msg>
    </section>
    <!-- Information -->
  
    <h3 id="information">Information</h3>
    <section class="structure-overview">
      <div *ngFor="let group of summaryTexts let isLast = last" class="domain-info-grouped">
        <div class="info" *ngFor="let item of group">
            <span class="info__title">{{ item.label }}</span>
            <span class="info__content">
              <ng-container>
                <article>
                  <span *ngIf="item.label != 'Status'">
                    <span *ngIf="item.show_long">
                      <span [innerHTML]="item.text"></span>
                      <a
                        *ngIf="getShortenedText(item.text) != item.text"
                        class="vf-link"
                        (click)="switchText(item)"
                      >
                        <i class="icon icon-functional"></i> Show less
                      </a>
                    </span>
                    <span *ngIf="!item.show_long">
                      <span [innerHTML]="getShortenedText(item.text)"></span>
                      <a
                        class="vf-link"
                        *ngIf="checkIfHasToShowMore(item)"
                        (click)="switchText(item)"
                      >
                        <i class="icon icon-functional"></i> Show more
                      </a>
                    </span>
                  </span>
                  <a
                    *ngIf="item.source && item.source !== 'tooltip'"
                    target="_blank"
                    href="{{ item.source_url }}"
                    class="vf-link ext"
                    style="margin-left:4px"
                  >
                    go to {{ item.source }}</a
                  >
                
      
                  <span *ngIf="item.italic"
                    ><a
                      class="vf-link ext"
                      href="./search/organismScientificName/{{
                        commonService.escapeValue(item.searchText)
                      }}"
                      target="_blank"
                      style="margin-left:4px"
                      >go to search</a
                    ></span
                  >
                </article>
              </ng-container>
            </span>
          </div>
        </div>
    </section>
   
    <!-- Model Confidence Summary -->
    <section id="model-confidence-summary" class="primebtn">
      <button
      class="vf-button vf-button--primary vf-button--search-pdbe" (click)="navigateTo3DView('MConfidence')">
      View 3D and annotations
    </button>
    </section>
    <h3>Model Confidence Summary</h3>
    <div class="structure-overview" style="display: flex; flex-direction: column;"> 
      <div class="info">
        <p class="info__title">Average pLDDT</p>
        <p class="info__content">
          {{ averageplddtDisplay }}
        </p>
      </div>
      <div class="info">
        <p class="info__title">pLDDT distribution</p>
          <article style="display:flex; flex-direction: row;">
            <div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryHigh * 100) | number : '1.0-1' }}% Very high
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtConfident * 100) | number : '1.0-1' }}% High
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtLow * 100) | number : '1.0-1' }}% Low
              </div>
              <div class="plddtlegends">
                <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
                {{ (plddtData?.fractionPlddtVeryLow * 100) | number : '1.0-1' }}% Very low
              </div>
            </div>
          </article>
      </div>
      <div class="legendsmobile">
        <linear-legends type="plddt"></linear-legends>
      </div>
      <div class="legendstext">
        <span>pLDDT is a per-residue measure of local confidence <br /> 
          <a (click)="gaService.eventEmitter(
                'link_visit',
                'home_href_click',
                'click',
                'learn more mobile',
                '')" href="./faq/#faq-12" target="_blank" class="licenseLink" target="_blank">
                Learn more...
          </a></span>
      </div>
      <molstar-gallery></molstar-gallery>
      <app-pae-view
        *ngIf="entryData().paeDocUrl"
        [paeid]="'mobile-paeviewer'"
        [isMobilePae]="true"
        (selectedRegion)="cmSelectionUpdate($event)"
        (click)="
          gaService.eventEmitter(
            'pae-click',
            'pae',
            'click',
            accession(),
            undefined
          )
          "
        >
      </app-pae-view>
    </div>
     <!-- Audit History -->
    <h3 id="audit-history">Audit history</h3>
    <span class="audit-info"><b>Model creation date:</b> <span class="infodate"> {{ entryData()?.modelCreatedDate | date: 'd MMM y' }}</span>
     </span>
<br>
    <span class="audit-info"><b>Sequence version date:</b> <span class="infodate"> {{ uniprotData()?.sequence?.modified | date: 'd MMM y' }}</span>
    </span>

    <!-- Similar Proteins -->
  
    <h3 id="similar-proteins">Similar Proteins</h3>
    <section>
      <span class="qualify-span secondary">The section highlights proteins that are evolutionarily related, either by <b>
        sequence</b> or <b>structure.</b>
      </span>
        <br />
      <div class="qualify-span-title">Structure similarity cluster</div>
    
      <span class="qualify-span structure-overview">
        <div class="info">
          <span class="info__title">Sequence level</span>
          <span class="info__content">
            {{ clustermmseqData()?.clusterTotal || 0 }} {{ (clustermmseqData()?.clusterTotal || 0) === 1 ? 'protein' : 'proteins' }}
          </span>
        </div>
        <div class="info">
          <span class="info__title">Structure level</span>
          <span class="info__content">
            {{ clusterfoldseekData()?.clusterTotal || 0 }} {{ (clusterfoldseekData()?.clusterTotal || 0) === 1 ? 'protein' : 'proteins' }}
          </span>
        </div>
      </span>
      <span class="qualify-span secondary">These proteins share function and evolutionary history. 
        <a (click)="gaService.eventEmitter(
          'link_visit',
          'home_href_click',
          'click',
          'learn more mobile',
          '')" href="./faq/#faq-21" target="_blank" class="licenseLink" target="_blank">
          Learn more about this method...
       </a>
      </span>
      <div class="qualify-span-title">Similar structures</div>
  
      <span class="qualify-span structure-overview">
        <span class="qualify-span secondary">You can explore proteins with similar structures in the AlphaFold DB and the latest PDB releases. <br />
          <a (click)="gaService.eventEmitter(
                  'link_visit',
                  'home_href_click',
                  'click',
                  'learn more mobile',
                  '')" href="./faq/#faq-24" target="_blank" class="licenseLink" target="_blank">
                  Learn more about this method...
            </a></span>
      </span>
      <section class="primebtn">
        <button
        class="vf-button vf-button--primary vf-button--search-pdbe"  (click)="navigateTo3DView('SProteins')">
        Discover similar proteins
      </button>
      </section>
     
    </section>
  
    <!-- Feedback -->
  
    <section class="feedback" id="feedback">
      <h3>Tell us what you think of the new look</h3>
      <a class="vf-button vf-button--secondary vf-button--search-pdbe" style="color: #3B6FB6"
      href="https://docs.google.com/forms/d/e/1FAIpQLSd1PJBxxK7XYtvJMblnojSoykFD56P3ieeGZ7PCrRI3FtLF1Q/viewform"
      target="_blank"
      >Share your feedback</a
    >
    </section>
  
  <!-- Help -->
  <h3 id="help"></h3>
  <entry-page-footer [isEntryPage]="true" />
</main>
